// Add headers and parameter here based on different conditions
import storage from '@xto10x/storage/lib';
import { StorageKey } from '@xto10x/core/lib/constants';
import httpClient from '@xto10x/core/lib/httpClient';

export const apiUtils = {
  getHeaders: existingHeaders => {
    const orgInfo = storage.getDataFromLocal(StorageKey.ORG_INFO);
    const additionalHeaders = orgInfo?.pseudo_user ? { internal: true } : {};
    return {
      ...additionalHeaders,
      ...existingHeaders
    };
  },

  getParams: existingParams => {
    const additionalParams = {};
    return { ...existingParams, ...additionalParams };
  }
};

const commonHttpClient = {
  ...httpClient,
  get: (path, params, headers, options, useBlitzProductId) =>
    httpClient.get(
      path,
      apiUtils.getParams(params),
      apiUtils.getHeaders(headers),
      options,
      useBlitzProductId
    ),
  post: (path, data, params, headers, useBlitzProductId) =>
    httpClient.post(
      path,
      data,
      apiUtils.getParams(params),
      apiUtils.getHeaders(headers),
      useBlitzProductId
    ),
  delete: (path, data, params, headers, useBlitzProductId) =>
    httpClient.delete(
      path,
      data,
      apiUtils.getParams(params),
      apiUtils.getHeaders(headers),
      useBlitzProductId
    ),
  patch: (path, data, params, headers, useBlitzProductId) =>
    httpClient.patch(
      path,
      data,
      apiUtils.getParams(params),
      apiUtils.getHeaders(headers),
      useBlitzProductId
    ),
  put: (path, data, params, headers, useBlitzProductId) =>
    httpClient.put(
      path,
      data,
      apiUtils.getParams(params),
      apiUtils.getHeaders(headers),
      useBlitzProductId
    )
};

export default commonHttpClient;
